import React from 'react'

const BudgetPerformance = () => {
  return (
    <div>BudgetPerformance</div>
  )
}

export default BudgetPerformance